import React from "react";

function Settings() {
  return (
    <div className="space-y-6">

      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">Settings</h1>
        <p className="text-gray-500 text-sm">
          Manage system preferences and security
        </p>
      </div>

      {/* Account Settings */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h2 className="text-lg font-semibold text-gray-700 mb-4">
          Account Settings
        </h2>

        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-700 font-medium">
                Enable Two-Factor Authentication
              </p>
              <p className="text-sm text-gray-500">
                Add extra security to your account
              </p>
            </div>
            <input type="checkbox" className="w-5 h-5" />
          </div>

          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-700 font-medium">
                Email Notifications
              </p>
              <p className="text-sm text-gray-500">
                Receive updates about activities
              </p>
            </div>
            <input type="checkbox" defaultChecked className="w-5 h-5" />
          </div>
        </div>
      </div>

      {/* Password Change */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h2 className="text-lg font-semibold text-gray-700 mb-4">
          Change Password
        </h2>

        <div className="grid md:grid-cols-2 gap-4">
          <input
            type="password"
            placeholder="Current Password"
            className="p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            placeholder="New Password"
            className="p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <button className="mt-6 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition">
          Update Password
        </button>
      </div>

      {/* Danger Zone */}
        
        <button className="bg-red-600 text-white float-end px-6 py-2 rounded-lg hover:bg-red-700 transition">
          Delete Account
        </button>

    </div>
  );
}

export default Settings;
